import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CrewTimecardService } from '../../../pages/crew-timecard/services/crew-timecard.service';

@Component({
  selector: 'app-copy-crew-line-modal',
  templateUrl: './copy-crew-line-modal.component.html',
  styleUrls: ['./copy-crew-line-modal.component.css']
})
export class CopyCrewLineModalComponent implements OnInit {
  @ViewChild('groupClockForm', { static: true }) groupClockForm: NgForm;
  @Input() crewsList: any[];
  @Input() employees: any[];
  @Input() row: any;
  @Input() rowProperties: any[];
  @Input() sharedColumnInfo: any;
  @Input() payPeriod: any;

  addDisable: boolean;
  selectedCrew: any;
  selectedEmployees: any[] = [];
  showCraftClassBox: boolean;
  showEarnCodeDefaultCheckbox: boolean;
  useEmplDefaultCraftClass: boolean = true;
  useEmplDefaultEarnCode: boolean;

  constructor(private crewTimecardService: CrewTimecardService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    
    this.addDisable = false;
    //Remove Employee of Selected Row From Employee Dropdown
    let employeeOfSelectedRow = this.row.Employee.substring(0, this.row.Employee.indexOf("@"));
    this.showCraftClassBox = ((this.sharedColumnInfo.Craft != null && this.sharedColumnInfo.Craft.ColumnVisibilityModeID > 2) ||
      (this.sharedColumnInfo.Class != null && this.sharedColumnInfo.Class.ColumnVisibilityModeID > 2));
    this.showEarnCodeDefaultCheckbox = this.rowProperties.indexOf("EarnCode") > -1;
    this.useEmplDefaultEarnCode = true;
    for (let i = 0; i < this.employees.length; i++) {
      if (this.employees[i].Employee == employeeOfSelectedRow) {
        this.employees.splice(i, 1);
      }
    }

    //238738: Retrieved data from Database uses GMT to represent PostDate column
    if (this.rowProperties.indexOf("PostDate") > -1 && this.row["PostDate"] != null && typeof this.row["PostDate"].getMonth == 'function') {
      let yyyy = this.row["PostDate"].getFullYear().toString();
      let mm = (this.row["PostDate"].getMonth() + 1).toString();
      let dd = this.row["PostDate"].getDate().toString();
      this.row["PostDate"] = yyyy + "/" + mm + "/" + dd;
    }

    //238738: Type Dropdown values are pushed manually. Hence default label need to be assigned.
    if (this.rowProperties.indexOf("Type") > -1 && this.row.Type != null) {
      let type = this.row.Type.substr(0, this.row.Type.indexOf('@'));
      switch (type) {
        case "J":
          this.row["Type___@Value"] = "J - Job";
          break;
        case "M":
          this.row["Type___@Value"] = "M - Mechanic";
          break;
        case "S":
          this.row["Type___@Value"] = "S - SM Work Order";
          break;
      }
    }
  }

  crewChanged() {
    this.selectedEmployees = [];
    if (this.selectedCrew != null && this.selectedCrew.Crew != "") {
      let selectedEmployees = [];
      this.crewTimecardService.getCrewMember(this.selectedCrew.PRCRKeyID).then((response: any[]) => {
        let crewMemberList = response;
        let employeeMap = this.employees.map((x) => { return x.Employee });
        for (let i = 0; i < crewMemberList.length; i++) {
          let crewMember = crewMemberList[i];
          let employeeIndex = employeeMap.indexOf(crewMember.Employee);
          if (employeeIndex > -1) {
            selectedEmployees.push(this.employees[employeeIndex]);
          }
        }
        this.selectedEmployees = selectedEmployees;
      });
    }
  }

  selectAllEmployees() {
    this.selectedEmployees = this.employees;
  }

  selectNoneEmployees() {
    this.selectedEmployees = [];
  }

  addClicked() {
    this.activeModal.close({
      selectedEmployees: this.selectedEmployees,
      useEmpDefaultCraftClass: this.useEmplDefaultCraftClass,
      useEmplDefaultEarnCode: this.useEmplDefaultEarnCode
    })
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

}
